// frontend/src/features/equipment/EquipmentSetupWizard/steps/ControlStep.tsx
import { CategoryStep } from './CategoryStep';
import type { PendingEquipment } from '../types';

interface ControlStepProps {
  pendingEquipment: PendingEquipment[];
  onEquipmentChange: (equipment: PendingEquipment[]) => void;
  onManageInEquipment?: () => void;
  isCategoryComplete?: boolean;
}

export function ControlStep({
  pendingEquipment,
  onEquipmentChange,
  onManageInEquipment,
  isCategoryComplete,
}: ControlStepProps) {
  return (
    <CategoryStep
      categoryId="control"
      title="What's controlling your tank?"
      pendingEquipment={pendingEquipment}
      onEquipmentChange={onEquipmentChange}
      onManageInEquipment={onManageInEquipment}
      isCategoryComplete={isCategoryComplete}
    />
  );
}
